import EmailVerificationModal from 'components/GlobalModals/EmailVerificationModal/EmailVerificationModal';
import { withEmailVerificationModalProps } from 'viewModel/globalModals/emailVerificationModal/withEmailVerificationModalProps';

export default withEmailVerificationModalProps(EmailVerificationModal);
